import * as React from 'react'

import { ContractsBankHolidayTreatmentEnum } from 'generated/resources/graphql'
import { WorkingConditionVersionApplicationFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  bankHolidayTreatment: ContractsBankHolidayTreatmentEnum
  workingConditionVersionApplication?: WorkingConditionVersionApplicationFragment
}

const BankHolidayTreatment = ({
  bankHolidayTreatment,
  workingConditionVersionApplication,
}: Props) => {
  let description: string

  switch (bankHolidayTreatment) {
    case 'workable':
      description = i18n.t('contract_versions.time.bank_holidays.working_time')
      break
    case 'non_workable':
      description = i18n.t('contract_versions.time.bank_holidays.non_working_time')
      break
    default:
      const exhaustiveCheck: never = bankHolidayTreatment
      throw new Error(`Unhandled bankHolidayTreatment: ${exhaustiveCheck}`)
  }

  return (
    <Item
      id="bank_holiday_treatment"
      title={i18n.t('contract_versions.time.bank_holidays.title')}
      description={description}
      workingConditionVersionApplication={workingConditionVersionApplication}
    />
  )
}

export default observer(BankHolidayTreatment)
